import styled from "styled-components";

export const SkillDetails = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem auto 0 auto;
  align-items: center;
  gap: 10px;
  padding: 0 20px 20px 20px;
  max-width: 500px;

  @media (min-width: 468px) {
	flex-direction: row;
	align-items:center;
	margin: 10px auto 20px auto;
	}

	@media (min-width: 800px) {
		margin: 10px auto 40px auto;
		padding: 0;
	}
`;

export const SkillIcon = styled.img`
  width: 40px;
  margin: 0;

  @media (min-width: 768px) {
	margin: 0 10px;
	}
`;

export const SkillsList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style: none;
  gap: 20px;
  padding: 0;
  margin: 10px 0;

  @media (min-width: 768px) {
	justify-content: flex-start;
	}
`;

export const SkillItem = styled.li`
  font-size: 16px;
  letter-spacing: 0.5px;
  font-weight: 500;
  color: #252525;

  @media (min-width: 768px) {
		font-size: 18px;
	}

	@media (min-width: 1024px) {
		font-size: 20px;
	}
`;

// old
export const SkillCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const StyledSkillLink = styled.a`
	color: var(--maindark);
	text-transform: uppercase;
	letter-spacing: 1px;
	position: relative;
	width: fit-content;
	margin: 0 0 1rem 0;
	text-decoration: none;
	cursor: pointer;

	&::after {
		content: "";
		position: absolute;
		width: 0;
		height: 4px;
		bottom: -5px;
		left: 0;
		background-color: var(--accent-turkoise);
		transform-origin: left;
		transition: width 0.5s ease;
		visibility: hidden;
	}

	&:hover::after {
		visibility: visible;
		width: 100%;
	}
`;


export const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 97%;

  @media (min-width: 768px) {
	margin: 0 2rem;
	max-width: 620px;
	}

	@media (min-width: 1024px) {
    font-size: 18px;
    line-height: 30px;
    max-width: 700px;
	}
`;

export const KonsultDetailHeader = styled.h1`
  font-size: 20px;
  margin: 10px 0 0 0;
  font-weight: 500;
  padding: 0 20px;

   /* Tablet  */
   @media (min-width: 768px) {
	margin:0;
  }

  /* Desktop */
  @media (min-width: 1024px) {
  }
`;

export const KonsultDetailText = styled.p`
  color: var(--darktext);
  font-weight: 300;
  font-size: 16px;
  margin: 20px 0;
  line-height: 20px;
  white-space: pre-line;
  padding: 0 20px;

  /* Tablet  */
  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 26px;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 18px;
    line-height: 30px;
  }
  `;